import { Col, Container, Row } from "react-bootstrap";
import Header from "../../components/header";
import Footer from "../../components/footer";
import "./styles.scss";
import { IoIosArrowForward } from "react-icons/io";
import { MdOutlineWhatsapp } from "react-icons/md";
import { RiFacebookCircleLine } from "react-icons/ri";
import { BsInstagram } from "react-icons/bs";
import { FaXTwitter } from "react-icons/fa6";
import { IoEarthSharp, IoLocationOutline } from "react-icons/io5";
import { MdArrowOutward } from "react-icons/md";
import BookNow from "../../assets/images/booknow.webp";
import Ticket from "../../assets/images/ticket.png";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HelmetSeo from "../../components/helmetSeo";
import { VscFeedback } from "react-icons/vsc";
import Card from "./components/card";
import { GET } from "../../utils/apiRequest";
import { notification } from "antd";
import { IoCalendarOutline } from "react-icons/io5";
const Fade = require("react-reveal/Fade");

function ShareScreena(props: any) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [fullDetails, setFullDetails] = useState<any>([]); // Changed to array to hold ticket data
  const [visible, setVisible] = useState(false);
  const [error, setError] = useState(false);
  const [expandedTickets, setExpandedTickets] = useState<{
    [key: string]: boolean;
  }>({});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleClick = () => {
    navigate("/feedback");
  };

  const toggleActivities = (ticketId: string) => {
    setExpandedTickets((prev) => ({
      ...prev,
      [ticketId]: !prev[ticketId],
    }));
  };

  const handleSearch = async (searchCardNo: any) => {
    setIsLoading(true);
    try {
      const response: any = await GET("card/search/" + searchCardNo);
      if (response?.status) {
        setFullDetails(response?.data); // Assuming response.data is the ticket array
        setVisible(false);
      } else {
        setFullDetails([]);
        notification.error({
          message: "Card not found!",
          description:
            "Please check your card number or reach out to our staff.",
        });
        setError(true);
      }
    } catch (err) {
      notification.error({
        message: "Oops!",
        description: "Something went wrong. Please refresh and try again.",
      });
    }
    setIsLoading(false);
  };

  return (
    <div>
      <HelmetSeo
        title="Share Screen"
        description={`Share the Social Media of Teenzania`}
        image="https://bairuha-bucket.s3.ap-south-1.amazonaws.com/teenzania/seo/teenzaniLogo.png"
        canonicalurl="https://www.teenzania.com/share"
        imageAlt="Sharescreen"
      />
      <Header />
      <div className="LayoutBox">
        <br />
        <Container>
          <Row>
            <Col sm={{ span: 12 }} xs={12}>
              <div className="heading_bredcume">
                Home <IoIosArrowForward /> Account <IoIosArrowForward /> Share
              </div>
              <h3 className="heading_h3">Share Now</h3>
              <br />
              <Row>
                <Col md={4} style={{ marginBottom: 25 }}>
                  <Fade top>
                    <Card
                      handleSearch={(val: any) => handleSearch(val)}
                      setVisible={setVisible}
                      visible={visible}
                      fullDetails={fullDetails}
                      isLoading={isLoading}
                      error={error}
                    />
                  </Fade>
                </Col>
              </Row>
              {/* New Section for Ticket Listing */}
              {fullDetails.tickets?.length > 0 && (
                <>
                  <br />
                  <h3 className="heading_h3">Your Tickets</h3>
                  <Row>
                    {fullDetails.tickets?.map((ticket: any, index: number) => {
                      // Get the first activity and the rest
                      const firstActivity = ticket.activities[0];
                      const hasMoreActivities = ticket.activities.length > 1;
                      const remainingActivities = hasMoreActivities
                        ? ticket.activities.slice(1)
                        : [];
                      const isExpanded =
                        expandedTickets[ticket.ticketNumber] || false;

                      return (
                        <Col md={4} sm={12} xs={12} key={index}>
                          <Fade top delay={index * 100}>
                            <div className="TicketBox">
                              <div className="ticket-header">
                                <div className="ticket-number">
                                  Ticket #{ticket.ticketNumber}
                                </div>
                                <div
                                  className={`ticket-status ${ticket.status ? "active" : "inactive"}`}
                                >
                                  {ticket.status ? "Active" : "Inactive"}
                                </div>
                              </div>

                              <div className="ticket-body">
                                <div className="ticket-activities">
                                  <div className="activity-title">
                                    Activities:
                                  </div>
                                  <ul>
                                    {/* Always show the first activity */}
                                    <li>
                                      <span className="activity-name">
                                        {firstActivity.name}
                                      </span>
                                      <span className="activity-price">
                                        {firstActivity.price
                                          .map(
                                            (p: any) => `${p.age}: ₹${p.price}`
                                          )
                                          .join(", ")}
                                      </span>
                                    </li>

                                    {/* Show remaining activities only if this ticket is expanded */}
                                    {isExpanded &&
                                      remainingActivities.map(
                                        (activity: any, idx: number) => (
                                          <li key={idx + 1}>
                                            <span className="activity-name">
                                              {activity.name}
                                            </span>
                                            <span className="activity-price">
                                              {activity.price
                                                .map(
                                                  (p: any) =>
                                                    `${p.age}: ₹${p.price}`
                                                )
                                                .join(", ")}
                                            </span>
                                          </li>
                                        )
                                      )}
                                  </ul>

                                  {/* Show the "Show More" button only if there are more activities */}
                                  {hasMoreActivities && (
                                    <button
                                      className="show-more-btn"
                                      onClick={() =>
                                        toggleActivities(ticket.ticketNumber)
                                      }
                                    >
                                      {isExpanded
                                        ? "Show Less"
                                        : `Show More (${remainingActivities.length})`}
                                    </button>
                                  )}
                                </div>
                              </div>

                              <div className="ticket-footer">
                                {/* <div className="ticket-amount">
                                  Total: ₹{ticket.totalAmount}
                                </div> */}
                                <div className="ticket-date">
                                  <IoCalendarOutline size={16} />
                                  {new Date(
                                    ticket.createdAt
                                  ).toLocaleDateString()}
                                </div>
                              </div>
                            </div>
                          </Fade>
                        </Col>
                      );
                    })}
                  </Row>
                </>
              )}

              <Row>
                <Col
                  md={3}
                  sm={12}
                  xs={12}
                  style={{ marginBottom: 25 }}
                  onClick={handleClick}
                >
                  <Fade top delay={400}>
                    <div className="ShareBox">
                      <div>
                        <VscFeedback size={30} color="#B8860B" />
                        <div className="ShareBox-txt1">Feedback</div>
                      </div>
                      <div>
                        <MdArrowOutward color="grey" />
                      </div>
                    </div>
                  </Fade>
                </Col>
                <Col md={3} sm={12} xs={12} style={{ marginBottom: 25 }}>
                  <a
                    href="https://wa.me/+917001800600"
                    style={{ textDecoration: "none", color: "black" }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Fade top delay={100}>
                      <div className="ShareBox">
                        <div>
                          <MdOutlineWhatsapp size={30} color="#25d366" />
                          <div className="ShareBox-txt1">Whatsapp</div>
                        </div>
                        <MdArrowOutward color="grey" />
                      </div>
                    </Fade>
                  </a>
                </Col>
                <Col md={3} sm={12} xs={12} style={{ marginBottom: 25 }}>
                  <a
                    href="https://www.instagram.com/teenzania_adventure_park/ "
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    <Fade top delay={200}>
                      <div className="ShareBox">
                        <div>
                          <div>
                            <BsInstagram size={30} color="#E1306C" />
                            <div className="ShareBox-txt1">Instagram</div>
                          </div>
                        </div>
                        <div>
                          <MdArrowOutward color="grey" />
                        </div>
                      </div>
                    </Fade>
                  </a>
                </Col>
                <Col md={3} sm={12} xs={12} style={{ marginBottom: 25 }}>
                  <a
                    href="https://www.facebook.com/profile.php?id=61557318977943"
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    <Fade top delay={300}>
                      <div className="ShareBox">
                        <div>
                          <RiFacebookCircleLine size={30} color="#4267B2" />
                          <div className="ShareBox-txt1">facebook</div>
                        </div>
                        <div>
                          <MdArrowOutward color="grey" />
                        </div>
                      </div>
                    </Fade>
                  </a>
                </Col>
                <Col md={3} sm={12} xs={12} style={{ marginBottom: 25 }}>
                  <a
                    href="https://twitter.com/Teenzania_"
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    <Fade top delay={400}>
                      <div className="ShareBox">
                        <div>
                          <FaXTwitter size={30} color="#000" />
                          <div className="ShareBox-txt1">Twitter</div>
                        </div>
                        <div>
                          <MdArrowOutward color="grey" />
                        </div>
                      </div>
                    </Fade>
                  </a>
                </Col>
                <Col md={3} sm={12} xs={12} style={{ marginBottom: 25 }}>
                  <a
                    href="https://teenzania.com"
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    <Fade top delay={400}>
                      <div className="ShareBox">
                        <div>
                          <IoEarthSharp size={30} color="#1d53d1" />
                          <div className="ShareBox-txt1">Website</div>
                        </div>
                        <div>
                          <MdArrowOutward color="grey" />
                        </div>
                      </div>
                    </Fade>
                  </a>
                </Col>
                <Col md={3} sm={12} xs={12} style={{ marginBottom: 25 }}>
                  <Fade top>
                    <div className="ShareBox">
                      <div>
                        <IoLocationOutline size={30} color="#188a8a" />
                        <div className="ShareBox-txt1">Location</div>
                      </div>
                      <MdArrowOutward color="grey" />
                    </div>
                  </Fade>
                </Col>
              </Row>
              <br />
              <Row>
                <Col
                  md={3}
                  sm={12}
                  xs={12}
                  style={{ marginBottom: 25 }}
                  onClick={() => navigate("/booking")}
                >
                  <Fade top delay={500}>
                    <div className="ShareBox">
                      <div>
                        <img
                          src={BookNow}
                          className="ShareBox-img"
                          alt="booknow"
                        />
                        <br />
                        <div style={{ fontSize: 25 }}>Book Now</div>
                      </div>
                      <div>
                        <MdArrowOutward color="grey" />
                      </div>
                    </div>
                  </Fade>
                </Col>
                <Col md={3} sm={12} xs={12} style={{ marginBottom: 25 }}>
                  <Fade top delay={600}>
                    <div className="ShareBox" onClick={() => navigate("/self")}>
                      <div>
                        <img
                          src={Ticket}
                          className="ShareBox-img"
                          alt="ticket"
                        />
                        <br />
                        <div style={{ fontSize: 25 }}>Get Tickets</div>
                      </div>
                      <div>
                        <MdArrowOutward color="grey" />
                      </div>
                    </div>
                  </Fade>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <br />
      </div>
      <Footer />
    </div>
  );
}

export default ShareScreena;
